var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5H37.5V30H9.69375L7.5 32.1938V7.5ZM7.5 3.75C5.4375 3.75 3.76875 5.4375 3.76875 7.5L3.75 41.25L11.25 33.75H37.5C39.5625 33.75 41.25 32.0625 41.25 30V7.5C41.25 5.4375 39.5625 3.75 37.5 3.75H7.5ZM11.25 22.5H33.75V26.25H11.25V22.5ZM11.25 16.875H33.75V20.625H11.25V16.875ZM11.25 11.25H33.75V15H11.25V11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.6a70c9d80d90dae42a59ffdc1c21250f.svg";
export { ForwardRef as ReactComponent };